import { useSiloWeb3 } from '@silo/web3';
import posthog from 'posthog-js';
import { FC } from 'react';
import { PulsePanel } from '../common/PulsePanel';
import { DoWithdraw, WithdrawForm } from './WithdrawForm';
import { ProtocolInstance } from '@silo/types';

type WithdrawPanelState =
  | { tag: 'loading' }
  // TODO: look into using React suspense for these values
  | { tag: 'loaded'; protocolInstance: ProtocolInstance };
// | { tag: 'frozen' };

const useWithdrawPanelState = (): WithdrawPanelState => {
  const { protocolInstance } = useSiloWeb3();

  if (protocolInstance === undefined) return { tag: 'loading' };

  return { tag: 'loaded', protocolInstance };
};

export interface WithdrawPanelProps {
  doWithdraw: DoWithdraw;
}

export const WithdrawPanel: FC<WithdrawPanelProps> = ({ doWithdraw }) => {
  const withdrawPanelState = useWithdrawPanelState();
  const { account } = useSiloWeb3();

  switch (withdrawPanelState.tag) {
    case 'loading':
    default:
      return <PulsePanel />;
    case 'loaded': {
      const { protocolInstance } = withdrawPanelState;
      posthog.identify(account);

      return <WithdrawForm protocolInstance={protocolInstance} doWithdraw={doWithdraw} />;
    }
  }
};
